import { createFileRoute } from "@tanstack/react-router"

import { preloadFlags } from "@/components/icons/FlagIcon"
import { SpinnerLayout } from "@/components/layouts/SpinnerLayout"
import { GeolocationProvider } from "@/helpers/GeolocationProvider"
import { ALL_APP_LANGUAGES, detectBrowserLanguage } from "@/locales/detectBrowserLanguage"
import { applyLanguage, preloadLocaleResources } from "@/locales/i18n"
import { readPersistedLanguage } from "@/locales/persistedLanguage"
import { StaticPermissionsPage } from "@/sections/permissions/StaticPermissionsPage"

export const Route = createFileRoute("/permissions")({
  loader: async () => {
    // No customer to resolve a language or an organization bundle from, so the browser decides and
    // the default translations are used
    await applyLanguage(readPersistedLanguage() ?? detectBrowserLanguage())

    // The switcher offers every language, so every bundle and flag has to be in place
    await Promise.all([preloadLocaleResources(ALL_APP_LANGUAGES), preloadFlags(ALL_APP_LANGUAGES)])
  },
  pendingComponent: () => <SpinnerLayout hideLogo={true} />,
  component: StaticPermissionsRoute,
})

function StaticPermissionsRoute() {
  // watchPosition is the single source of truth for geolocation: it triggers the prompt and
  // produces the permission state this page shows
  return (
    <GeolocationProvider enabled>
      <StaticPermissionsPage />
    </GeolocationProvider>
  )
}
